var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            title: "Flipbook Management",
            centered: "",
            "ok-title": _vm.activeTab === 1 ? "Go to Flipbook" : "",
            "ok-disabled":
              _vm.activeTab === 1
                ? !(_vm.handledCatalog || _vm.selectedCatalog)
                : true,
            "hide-footer": _vm.activeTab === 0,
          },
          on: { ok: _vm.goToCatalog, cancel: _vm.onClose },
          model: {
            value: _vm.isOpened,
            callback: function ($$v) {
              _vm.isOpened = $$v
            },
            expression: "isOpened",
          },
        },
        [
          _c(
            "b-tabs",
            {
              attrs: { "content-class": "mt-3", "nav-class": "custom-tabs" },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "b-tab",
                {
                  attrs: { title: "Create Flipbook", active: "" },
                  on: { click: _vm.onTabClick },
                },
                [
                  _c(
                    "div",
                    { attrs: { role: "group" } },
                    [
                      _c("label", { attrs: { for: "input-live" } }, [
                        _vm._v("Name"),
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        attrs: {
                          state: _vm.nameState,
                          placeholder: "Enter name",
                          "aria-describedby": "input-live-feedback",
                          trim: "",
                        },
                        model: {
                          value: _vm.name,
                          callback: function ($$v) {
                            _vm.name = $$v
                          },
                          expression: "name",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-form-invalid-feedback",
                        { attrs: { id: "input-live-feedback" } },
                        [
                          _vm._v(
                            "\n            Enter a name of at least 1 and less than 255 chars.\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "brand-section mt-3" }, [
                    _c("div", { staticClass: "brand-header" }, [
                      _c("span", { staticClass: "brand-label" }, [
                        _vm._v("Brand"),
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "brand-default-check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.setAsDefault,
                              expression: "setAsDefault",
                            },
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.setAsDefault)
                              ? _vm._i(_vm.setAsDefault, null) > -1
                              : _vm.setAsDefault,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.setAsDefault,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.setAsDefault = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.setAsDefault = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.setAsDefault = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Set as default")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "brand-row" }, [
                      _c("div", { staticClass: "logo-box" }, [
                        !_vm.logoUrl
                          ? _c("span", [_vm._v("LOGO")])
                          : _c("img", {
                              attrs: { src: _vm.logoUrl, alt: "Logo preview" },
                            }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "tb-action",
                          attrs: { type: "button" },
                          on: { click: _vm.triggerFileInput },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            },
                            [
                              _c("path", { attrs: { d: "M12 19V5" } }),
                              _vm._v(" "),
                              _c("path", { attrs: { d: "M5 12l7-7 7 7" } }),
                            ]
                          ),
                          _vm._v("\n              Upload\n            "),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "tb-action",
                          attrs: { type: "button" },
                          on: { click: _vm.openFileBrowser },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z",
                                },
                              }),
                            ]
                          ),
                          _vm._v("\n              File Browser\n            "),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "click-outside",
                              rawName: "v-click-outside",
                              value: _vm.closePicker,
                              expression: "closePicker",
                            },
                          ],
                          staticClass: "brand-color-wrap",
                        },
                        [
                          _c("button", {
                            staticClass: "brand-color-swatch",
                            style: { backgroundColor: _vm.brandColor },
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                _vm.pickerOpen = !_vm.pickerOpen
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.pickerOpen
                            ? _c("ColorPickerPopover", {
                                staticClass: "brand-color-popover",
                                model: {
                                  value: _vm.brandColor,
                                  callback: function ($$v) {
                                    _vm.brandColor = $$v
                                  },
                                  expression: "brandColor",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      ref: "fileInput",
                      staticClass: "d-none",
                      attrs: { type: "file", accept: "image/*" },
                      on: { change: _vm.onFileSelected },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    { staticClass: "mt-3 catalog-cover-upload" },
                    [
                      _c("input", {
                        ref: "coverImageInput",
                        staticClass: "d-none",
                        attrs: { type: "file", accept: "image/*" },
                        on: { change: _vm.onCoverImageChange },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "catalog-cover-upload__content d-flex align-items-center justify-content-between gap-2",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center gap-2" },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass:
                                    "text-primary catalog-cover-upload__icon-info",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", { attrs: { d: "M20 3v4" } }),
                                  _c("path", { attrs: { d: "M22 5h-4" } }),
                                  _vm._v(" "),
                                  _c("path", { attrs: { d: "M4 17v2" } }),
                                  _c("path", { attrs: { d: "M5 18H3" } }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "font-sm" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.coverImage
                                        ? "Cover auto-generated from custom upload"
                                        : "Cover auto-generated from first layout"
                                    ) +
                                    "\n              "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-link p-0 font-sm",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.$refs.coverImageInput.click()
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "bi bi-upload mr-1 catalog-cover-upload__icon-upload",
                              }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.coverImage ? "Replace" : "Upload custom"
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-3", attrs: { role: "group" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center justify-content-between gap-2",
                        },
                        [
                          _c("label", { staticClass: "mb-0" }, [
                            _vm._v("Password"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "mr-3",
                              model: {
                                value: _vm.requirePassword,
                                callback: function ($$v) {
                                  _vm.requirePassword = $$v
                                },
                                expression: "requirePassword",
                              },
                            },
                            [
                              _vm._v(
                                "\n              Require password to view\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-form-input", {
                        staticClass: "mt-2",
                        attrs: {
                          state: _vm.passwordState,
                          disabled: !_vm.requirePassword,
                          placeholder: "Password",
                        },
                        model: {
                          value: _vm.password,
                          callback: function ($$v) {
                            _vm.password = $$v
                          },
                          expression: "password",
                        },
                      }),
                      _vm._v(" "),
                      _vm.requirePassword
                        ? _c("b-form-invalid-feedback", [
                            _vm._v(
                              "\n            Password must be at least 4 characters.\n          "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "mt-3 d-flex justify-content-end align-center gap-2",
                    },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              modifiers: { hover: true },
                            },
                          ],
                          staticClass: "text-dark",
                          attrs: { variant: "link", title: "Close" },
                          on: { click: _vm.onClose },
                        },
                        [_vm._v("\n            Cancel\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              modifiers: { hover: true },
                            },
                          ],
                          attrs: {
                            variant: "primary",
                            disabled:
                              !_vm.nameState ||
                              (_vm.requirePassword && !_vm.passwordState),
                            title: "Create and copy link to clipboard",
                          },
                          on: { click: _vm.createAndCopy },
                        },
                        [
                          _c("i", { staticClass: "bi bi-copy" }),
                          _vm._v(
                            "\n            Create & copy link\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              modifiers: { hover: true },
                            },
                          ],
                          attrs: {
                            variant: "outline-primary",
                            disabled:
                              !_vm.nameState ||
                              (_vm.requirePassword && !_vm.passwordState),
                            title: "Create and open in new tab",
                          },
                          on: { click: _vm.createAndOpen },
                        },
                        [_c("i", { staticClass: "bi bi-box-arrow-up-right" })]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: { title: "Add to Flipbook" },
                  on: { click: _vm.onTabClick },
                },
                [
                  _c("b-pagination", {
                    attrs: {
                      "total-rows": _vm.catalogsCount,
                      "per-page": _vm.catalogsPerPage,
                    },
                    on: { change: _vm.getCatalogList },
                    model: {
                      value: _vm.catalogsPage,
                      callback: function ($$v) {
                        _vm.catalogsPage = $$v
                      },
                      expression: "catalogsPage",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "b-list-group",
                    _vm._l(_vm.catalogs, function (catalog) {
                      return _c(
                        "b-list-group-item",
                        {
                          key: catalog.id,
                          staticClass:
                            "cursor-pointer d-flex justify-content-between catalog-item",
                          attrs: { active: _vm.selectedCatalog === catalog },
                          on: {
                            click: function ($event) {
                              _vm.selectedCatalog = catalog
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(catalog.name) +
                              "\n            "
                          ),
                          _c(
                            "div",
                            { staticClass: "catalog-item__buttons" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "btn-sm",
                                  attrs: { variant: "outline-dark" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.onRenameBtnClick(catalog)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "bi bi-pencil-square",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  staticClass: "btn-sm",
                                  attrs: { variant: "outline-danger" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.deleteCatalog(catalog.id)
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "bi bi-trash" })]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-3",
                      attrs: {
                        variant: "primary",
                        disabled: !_vm.selectedCatalog,
                      },
                      on: { click: _vm.addToCatalog },
                    },
                    [_vm._v("\n          Add to selected Flipbook\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("EditCatalogModal", {
        attrs: { catalog: _vm.selectedCatalog },
        on: { catalogUpdated: _vm.onCatalogUpdated },
      }),
      _vm._v(" "),
      _c("SelectFolderModal", {
        attrs: { mode: "select" },
        on: { onSelectedItems: _vm.onSelectedItems },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }